import React, { useEffect, useState } from "react";
import { useStores } from "@/store";
import { useTranslation } from "react-i18next";
import "./index.less";

export default function Card({
  deal = {},
  showHandler = false,
  onDealClick,
  qty = 1,
  min = 1,
  max = 1,
  setQty,
  onLimit,
}) {
  const [distance, setDistance] = useState(0);
  const { memberStore } = useStores();
  const { t } = useTranslation();
  const showSoldBtn =
    onDealClick &&
    deal.can_buy_walk_in &&
    deal.inventory === 0 &&
    deal.use_type === "walk_in";
  const showGetBtn =
    onDealClick &&
    deal.can_buy_walk_in &&
    (deal.use_type === "walk_in" ? deal.inventory > 0 : true);

  useEffect(() => {
    const { area_range } = deal || {};
    if (area_range) {
      setDistance(
        area_range > 1000
          ? `${(area_range / 1000).toFixed(1)}km`
          : `${Math.ceil(area_range)}m`
      );
    } else {
      const { lat, lng } = deal.restaurant || {};
      setDistance(memberStore.getDistance(lat, lng));
    }
  }, []);

  function onClick(evt) {
    evt.preventDefault();
    onDealClick && onDealClick(deal);
  }

  if (!deal) return null;

  return (
    <div className="buydeal-card" onClick={onClick}>
      <img
        src={deal.picture_url?.split("?")[0] + "-thumb"}
        width={102}
        height={102}
        className="buydeal-card-img"
      />
      <div className="buydeal-card-body">
        <div className="buydeal-card-title">{deal.name}</div>
        <div className="buydeal-card-desc">{deal.restaurant_name}</div>
        <div className="buydeal-card-row" style={{ marginBottom: "4px" }}>
          <div className="buydeal-card-tags">
            <div className="buydeal-card-tag">{deal.category_name}</div>
            {deal.use_type === "book" && (
              <div className="buydeal-card-tag">
                {t("walkin.BookingRequired")}
              </div>
            )}
          </div>
          <div className="buydeal-card-price">{deal.format_deal_price}</div>
        </div>
        <div className="buydeal-card-row">
          <div className="buydeal-card-address">
            <img src={require("../images/address.svg")} alt="" />
            <span>
              {Array.isArray(deal?.locations)
                ? deal?.locations[0]?.name
                : deal?.locations?.name}
            </span>
            <i hidden={!distance}></i>
            <span>{distance}</span>
          </div>
          {showHandler && (
            <Handler
              qty={qty}
              min={min}
              max={max}
              setQty={setQty}
              onLimit={onLimit}
            />
          )}
          {showGetBtn && (
            <div className="get-button">{t("walkin.Buy now")}</div>
          )}
          {showSoldBtn && (
            <div className="sold-button">{t("walkin.SoldOut")}</div>
          )}
        </div>
      </div>
    </div>
  );
}

const Handler = ({ qty, min, max, setQty, onLimit }) => {
  const onMinus = (evt) => {
    evt.stopPropagation();
    if (qty > min) {
      setQty(qty - 1);
    }
  };
  const onPlus = (evt) => {
    evt.stopPropagation();
    if (qty === max) {
      onLimit && onLimit();
    } else if (qty < max) {
      setQty(qty + 1);
    }
  };
  return (
    <div className="buydeal-card-handler">
      <div
        className="buydeal-card-btn"
        data-disabled={qty <= min}
        onClick={onMinus}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="10"
          height="2"
          viewBox="0 0 10 2"
          fill="none"
        >
          <path
            d="M9.09961 0.5V0.700195H0.5V0.5H9.09961Z"
            fill="#333333"
            stroke="#999999"
          />
        </svg>
      </div>
      <div className="buydeal-card-input">{qty}</div>
      <div
        className="buydeal-card-btn"
        data-disabled={qty >= max}
        onClick={onPlus}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="10"
          height="10"
          viewBox="0 0 10 10"
          fill="none"
        >
          <path
            d="M9.09961 4.90039V5.10059H0.5V4.90039H9.09961Z"
            fill="#666666"
            stroke="#666666"
          />
          <path
            d="M4.8999 9.2998L4.69971 9.2998L4.69971 0.700195L4.8999 0.700195L4.8999 9.2998Z"
            fill="#666666"
            stroke="#666666"
          />
        </svg>
      </div>
    </div>
  );
};
